import { ReturnToTray } from "../Tabs/TrayItemsClickedActions/ReturnToTray";
import { CreatePlacedItemBackLog, RemoveFromBackLog } from "./BackSystems";
/**************************************************************************************/
/*Input events handles scene wide drag, dragstart, dragend, and pointer up events
*Tree top has seperate drag events in click handler
*This file is also responsible for placement rules, setting data on the placed objects
*and creating back log entries*/
/**************************************************************************************/

/**This Function should only be called once.
 * 
 * @param {*} Scene 
 */
export function SceneWideInputSetUpCall(Scene)
{
    //console.log(Scene.input.eventNames());
    var OldLocation = new Phaser.Math.Vector2;
    var ComparisonVector = new Phaser.Math.Vector2;
    
    //const PlaceCheckFunction = (TabName === 'Orn') ? _OrnPlaceTest : _GiftPlaceTest;
    Scene.input.on('dragstart',(Pointer, GameObject, Dx, Dy)=>
    {
        if(!Scene.DrawState)
        {
            Scene.AudioChan.Chan1.play('pick_up_ornament');
            OldLocation.setFromObject(GameObject);
        }
        if(GameObject.getData('AssetType') === "Gfts" && GameObject.depth < Scene.DepthList.GiftsForward)
        {
            GameObject.setDepth(Scene.DepthList.GiftsForward)
        }
        if(GameObject.getData('AssetType') == "Gfts")
        {
            let depth = GameObject.depth;
            Phaser.Utils.Array.BringToTop(Scene.children.list,GameObject);
            GameObject.setDepth(depth);
            //Scene.children.queueDepthSort();
        }
    });

    Scene.input.on('drag',(Pointer, GameObject, Dx, Dy)=>
    {
        //console.log(GameObject);
        //if (GameObject.getData('AssetType') != 'Lts')
        if (GameObject.type != 'Container' || Scene.LightDragOffset === "Empty")
        {
            //console.log("In drag");
            if(!Scene.DrawState)
            {
                //Draged = GameObject;

                GameObject.x = Dx;
                GameObject.y = Dy;
            }
        }
    });

    Scene.input.on('pointerup',(Pointer, GameObject, Dx, Dy)=>
    {
        //console.log("Scene wide pointer up check")
        //console.log(Scene.BackLog);
        if(Scene.LightDragOffset != "Empty")
        {
            Scene.LightDragOffset = "Empty"
        }
        if(Scene.InitialCheck)
        {
            switch(Scene.CurrentTabName)
            {
                case 'Grlnd':
                    _setTypeData(_decorPlaceTest(Scene, Pointer, Scene.DragObject),Scene.DragObject,Scene.CurrentTabName);
                    break;
                case 'Orn':
                    _setTypeData(_ornPlaceTest(Scene, Pointer, Scene.DragObject),Scene.DragObject,Scene.CurrentTabName);
                    break;
                case 'Gfts':
                    _setTypeData(_giftPlaceTest(Scene, Pointer, Scene.DragObject),Scene.DragObject,Scene.CurrentTabName);
                    break;
                default:
                    break;
            }
            Scene.InitialCheck = false;
        }
    });

    Scene.input.on('dragend',(Pointer, GameObject, Dx, Dy)=>
    {
        let BackLogCheck;
        //console.log(GameObject)
        ComparisonVector.setFromObject(GameObject);
        //console.log(GameObject);
        if(!Scene.DrawState)
        {
            if(Scene.InitialCheck === false && GameObject.getData('AssetType') === "Gfts" && Pointer.x < Scene.ActiveTree.getLeftCenter().x)
            {
                
                let leftCheck;
                if(GameObject.type === "Container")
                {
                    leftCheck = GameObject.getBounds().left;
                }
                else
                {
                    leftCheck = GameObject.getLeftCenter().x;
                }
                if(leftCheck < 338 && Scene.Tray.x < 200)
                {
                    GameObject.setDepth(GameObject.scene.DepthList.Gifts);
                    //console.log("Gift check")
                }
            }
            if(!ComparisonVector.equals(OldLocation))
            {
                switch(GameObject.getData('AssetType'))
                    {
                        case "Lts":
                        case 'Grlnd':
                            BackLogCheck = _decorPlaceTest(Scene, Pointer, GameObject);
                            break;
                        case 'Orn':
                            BackLogCheck = _ornPlaceTest(Scene, Pointer, GameObject);
                            break;
                        case 'Gfts':
                            BackLogCheck = _giftPlaceTest(Scene, Pointer, GameObject);
                            break;
                        default:
                            break;
                    }

                    if(BackLogCheck)
                    {
                        if(GameObject.getData('AssetType') != "Gfts")GameObject.scene.AudioChan.Chan1.play('place_ornament');
                        CreatePlacedItemBackLog(GameObject,"Moved",OldLocation);
                    }
                    else RemoveFromBackLog(Scene,GameObject);
            } 
        }       
    });
}
function _setTypeData(PlaceCheck,GameObject,Name)
{
    if(PlaceCheck)
    {
        if(Name != "Gfts")
        {
            GameObject.scene.AudioChan.Chan1.play('place_ornament');
        }
        else
        {
            //GameObject.setDepth(GameObject.scene.DepthList.Gifts);
        }
        GameObject.setData('AssetType',Name);

        CreatePlacedItemBackLog(GameObject,"Created");
    }
}

function _ornPlaceTest(Scene, Pointer, ObjectToCheck)
{
    let ObjectXY;
    let ReturnValue = true;
    //console.log(ObjectToCheck);
    if(ObjectToCheck.type === "Container")
    {
        //console.log("Cont");
        let Bounds = ObjectToCheck.getBounds();

        ObjectXY = new Phaser.Math.Vector2(Bounds.centerX,Bounds.top);
    }
    else
    {
        ObjectXY = new Phaser.Math.Vector2(ObjectToCheck.getTopCenter());
    }
    let HitBoxXY = new Phaser.Math.Vector2(Scene.HitBoxTree);
    let PointInHitBoxXY = new Phaser.Math.Vector2(ObjectXY.subtract(HitBoxXY));
    //console.log(Scene.input.manager.pointWithinHitArea(Scene.HitBoxTree,PointInHitBoxXY.x,PointInHitBoxXY.y));
    if(!Scene.input.manager.pointWithinHitArea(Scene.HitBoxTree,PointInHitBoxXY.x,PointInHitBoxXY.y))
    {
        ReturnToTray(ObjectToCheck);
        ReturnValue = false;
    }
    return ReturnValue;
}

function _decorPlaceTest(Scene,Pointer, ObjectToCheck)
{
    //console.log("Decor");

    let ReturnValue = true; 
    let ObjectXY;
    if(ObjectToCheck.type === "Container")
    {
        //console.log("Cont");
        let Bounds = ObjectToCheck.getBounds();

        ObjectXY = new Phaser.Math.Vector2(Bounds.centerX,Bounds.top);
    }
    else
    {
        if(ObjectToCheck.frame.name === 'Grlnd_Cndl')
        {
            ObjectXY = new Phaser.Math.Vector2(ObjectToCheck.getBottomCenter());
        }
        else
        {
            ObjectXY = new Phaser.Math.Vector2(ObjectToCheck.getCenter());
        }
    }
    let HitBoxXY = new Phaser.Math.Vector2(Scene.HitBoxTree);
    let PointInHitBoxXY = new Phaser.Math.Vector2(ObjectXY.subtract(HitBoxXY));
    //console.log(Scene.input.manager.pointWithinHitArea(Scene.HitBoxTree,PointInHitBoxXY.x,PointInHitBoxXY.y));
    if(!Scene.input.manager.pointWithinHitArea(Scene.HitBoxTree,PointInHitBoxXY.x,PointInHitBoxXY.y))
    {
        ReturnToTray(ObjectToCheck);
        ReturnValue = false;
    }
    Scene.InitialCheck = false;
    return ReturnValue;  
}

function _giftPlaceTest(Scene, Pointer, ObjectToCheck)
{
    //console.log("Gift");
    let ReturnValue = true;
    let PlaceCheck = Scene.input.hitTestPointer(Pointer);
    //console.log(PlaceCheck[0])
    let LeftX;
    let BottomRight;
    //console.log(ObjectToCheck);

    if(ObjectToCheck.type === "Container")
    {
        let Bounds = ObjectToCheck.getBounds();
        //console.log(Bounds);

        LeftX = Bounds.left;
        BottomRight = {x:Bounds.right,y:Bounds.bottom};
    }
    else
    {
        LeftX = ObjectToCheck.getLeftCenter().x;
        BottomRight = ObjectToCheck.getBottomRight();
    }
    //console.log(BottomRight.x);
    if(Pointer.y < 566 || LeftX < Scene.Tray.getRightCenter().x || BottomRight.y > 768 || BottomRight.x > 1024)
    {
        if(LeftX < Scene.Tray.getRightCenter().x || BottomRight.y > 768 || BottomRight.x > 1024)
        {
            //console.log("cont check")
            ReturnToTray(ObjectToCheck);
            ReturnValue = false;
        }
        else
        {
            _giftFall(ObjectToCheck,566);
            //ReturnValue = false;
        }
    }
    else
    { 
        if(PlaceCheck[0].type != "Container")
        {
            PlaceCheck = PlaceCheck[0].frame.name;
        }
        else
        {
            PlaceCheck = "Cont";
        }
        //if(PlaceCheck[])
        if(PlaceCheck === "Tree_SlimBG" || PlaceCheck === "Tree_PntyBG" || PlaceCheck === "Tree_FlufBG")
        {
            //console.log("Frame check")
            //ReturnToTray(ObjectToCheck);
            _giftFall(ObjectToCheck,620);
            //ReturnValue = false;
        }
        else
        {
            Scene.AudioChan.Chan1.play('place_ornament');
        }
    } 
    Scene.InitialCheck = false;
    return ReturnValue;
}

function _giftFall(Gift, Min)
{
    let RandY = Math.floor(Math.random()*202)+Min;
    let GiftHeight = Gift.height *.5;
    if(RandY + GiftHeight > 768) RandY = 768 - GiftHeight;
    
    let Scene = Gift.scene;

    let Time = (RandY - Gift.y)*.90; 
    let BounceDist = (RandY - Gift.y)*.1;

    Gift.disableInteractive();

    Scene.AudioChan.Chan3.play('present_shake');
    Scene.addTween(Gift,150,{angle:20},Phaser.Math.Easing.Quadratic.InOut,()=>
    {
        Scene.addTween(Gift,150,{angle:-20,yoyo:true},Phaser.Math.Easing.Quadratic.InOut,()=>
        {
            Scene.addTween(Gift,150,{angle:0},Phaser.Math.Easing.Quadratic.InOut,()=>
            {
                Scene.addTween(Gift,Time,{y:RandY},Phaser.Math.Easing.Quadratic.In,()=>
                {
                    Scene.AudioChan.Chan3.play('present_fireplace_land');
                    Scene.addTween(Gift,100,{y:Gift.y - BounceDist,yoyo:true},Phaser.Math.Easing.Quadratic.InOut,()=>
                    {
                        Gift.setInteractive();
                    });
                });
            });
        });
    });
    

    //Gift.y = RandY;
}
